import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick", "onMousedown"]
const _hoisted_2 = { class: "list-item-text" }

import TUIChatEngine, {
  TUIStore,
  TUITranslateService,
  IMessageModel,
} from '../../../../@aidesk/uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import vue from '../../../../adapter-vue';
import Icon from '../../../common/Icon.vue';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index-web';
import delIcon from '../../../../assets/msg-del.svg';
import copyIcon from '../../../../assets/msg-copy.svg';
import quoteIcon from '../../../../assets/msg-quote.svg';
import revokeIcon from '../../../../assets/msg-revoke.svg';
import downloadIcon from '../../../../assets/download.svg'
import { enableSampleTaskStatus } from '../../../../utils/enableSampleTaskStatus';
import { transformTextWithKeysToEmojiNames } from '../../emoji-config';
import { isH5, isPC, isUniFrameWork } from '../../../../utils/env';
import state from '../../../../utils/state.js';

// uni-app conditional compilation will not run the following code
// #ifndef APP || APP-PLUS || MP || H5
import CopyManager from '../../../../utils/copy-web';
// #endif

interface IProps {
  messageItem: IMessageModel;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index-web',
  props: {
    messageItem: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any, { expose: __expose }) {

const { ref, watchEffect, computed } = vue;
const props = __props;

const TYPES = TUIChatEngine.TYPES;

const messageToolDisplayConfig = state.get('messageToolDisplayConfig') || [];

const getMessageToolDisplayConfig = (key: string) => {
  if (!messageToolDisplayConfig || messageToolDisplayConfig.length === 0) {
    return undefined;
  }
  const item =  messageToolDisplayConfig.find(item => item.key === key);
  return item ? item.display : undefined;
}

const actionItems = ref([
  {
    key: 'open',
    text: TUITranslateService.t('TUIChat.打开'),
    iconUrl: copyIcon,
    renderCondition() {
      if (!message.value) return false;
      const config = getMessageToolDisplayConfig('open');
      if (config === false) {
        return false;
      }
      return (
        isPC
        && (message.value?.type === TYPES.MSG_FILE
        || message.value.type === TYPES.MSG_VIDEO
        || message.value.type === TYPES.MSG_IMAGE)
      );
    },
    clickEvent: openMessage,
  },
  {
    key: 'copy',
    text: TUITranslateService.t('TUIChat.复制'),
    iconUrl: copyIcon,
    renderCondition() {
      if (!message.value) return false;
      const config = getMessageToolDisplayConfig('copy');
      if (config === false) {
        return false;
      }
      return message.value.type === TYPES.MSG_TEXT;
    },
    clickEvent: copyMessage,
  },
  {
    key: 'revoke',
    text: TUITranslateService.t('TUIChat.撤回'),
    iconUrl: revokeIcon,
    renderCondition() {
      if (!message.value) return false;
      const config = getMessageToolDisplayConfig('revoke');
      if (config === false) {
        return false;
      }
      return message.value.flow === 'out' && message.value.status === 'success';
    },
    clickEvent: revokeMessage,
  },
  {
    key: 'delete',
    text: TUITranslateService.t('TUIChat.删除'),
    iconUrl: delIcon,
    renderCondition() {
      if (!message.value) return false;
      const config = getMessageToolDisplayConfig('delete');
      if (config === false) {
        return false;
      }
      return message.value.status === 'success';
    },
    clickEvent: deleteMessage,
  },
  {
    key: 'quote',
    text: TUITranslateService.t('TUIChat.引用'),
    iconUrl: quoteIcon,
    renderCondition() {
      if (!message.value) return false;
      const config = getMessageToolDisplayConfig('quote');
      if (config === false) {
        return false;
      }
      const _message = TUIStore.getMessageModel(message.value.ID);
      return message.value.status === 'success' && !_message.getSignalingInfo();
    },
    clickEvent: quoteMessage,
  },{
    key:'download',
    text: TUITranslateService.t('TUIChat.下载'),
    iconUrl: downloadIcon,
    renderCondition(){
      if (!message.value) return false;
      const config = getMessageToolDisplayConfig('download');
      if (config === false) {
        return false;
      }
      return message.value.type === TYPES.MSG_FILE && message.value.flow === 'out';
    },
    clickEvent:downloadMessage,
  }
]);

const message = ref<IMessageModel>();
const messageToolDom = ref<HTMLElement>();

watchEffect(() => {
  message.value = TUIStore.getMessageModel(props.messageItem.ID);
});

const isAllActionItemInvalid = computed(() => {
  for (let i = 0; i < actionItems.value.length; ++i) {
    if (actionItems.value[i].renderCondition()) {
      return false;
    }
  }
  return true;
});

function getFunction(index: number) {
  // Compatible with Vue2 and WeChat Mini Program syntax, dynamic binding is not allowed.
  actionItems.value[index].clickEvent();
}

function openMessage() {
  let url = '';
  switch (message.value?.type) {
    case TUIChatEngine.TYPES.MSG_FILE:
      url = message.value.payload.fileUrl;
      break;
    case TUIChatEngine.TYPES.MSG_VIDEO:
      url = message.value.payload.remoteVideoUrl;
      break;
    case TUIChatEngine.TYPES.MSG_IMAGE:
      url = message.value.payload.imageInfoArray[0].url;
      break;
  }
  window?.open(url, '_blank');
}

function revokeMessage() {
  if (!message.value) return;
  const messageModel = TUIStore.getMessageModel(message.value.ID);
  messageModel
    .revokeMessage()
    .then(() => {
      enableSampleTaskStatus('revokeMessage');
    })
    .catch((error: any) => {
      if (error.code === 20016) {
        const message = TUITranslateService.t('TUIChat.已过撤回时限');
        Toast({
          message,
          type: TOAST_TYPE.ERROR,
        });
      }
    });
}

function deleteMessage() {
  if (!message.value) return;
  const messageModel = TUIStore.getMessageModel(message.value.ID);
  messageModel.deleteMessage();
}

async function copyMessage() {
  if (isUniFrameWork) {
    TUIGlobal?.setClipboardData({
      data: transformTextWithKeysToEmojiNames(message.value?.payload?.text),
    });
  } else {
    // uni-app conditional compilation will not run the following code
    // #ifndef APP || APP-PLUS || MP || H5
    CopyManager.copySelection(message.value?.payload?.text);
    // #endif
  }
}

function beforeCopy(key: string) {
  // only pc support copy selection or copy full message text
  // uni-app and h5 only support copy full message text
  if (key !== 'copy' || isH5) {
    return;
  }

  // uni-app conditional compilation will not run the following code
  // #ifndef APP || APP-PLUS || MP || H5
  CopyManager.saveCurrentSelection();
  // #endif
}

function quoteMessage() {
  if (!message.value) return;
  message.value.quoteMessage();
}
 
function downloadMessage(){
  if(!message.value || message.value.hasRiskContent) return;
  const option = {
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    }),
  } as RequestInit;
  const content = message.value.getMessageContent();
  // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
  if ((window as any)?.fetch) {
    fetch(content.url, option)
      .then(res => res.blob())
      .then((blob) => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = content.name;
        a.click();
      });
  } else {
    const a = document.createElement('a');
    a.href = content.url;
    a.target = '_blank';
    a.download = content.name;
    a.click();
  }
}

__expose({
  messageToolDom,
});

return (_ctx: any,_cache: any) => {
  return (!_unref(isAllActionItemInvalid) && !__props.messageItem.hasRiskContent)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "messageToolDom",
        ref: messageToolDom,
        class: _normalizeClass(['dialog-item', !_unref(isPC) ? 'dialog-item-h5' : 'dialog-item-web'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["dialog-item-list", !_unref(isPC) ? 'dialog-item-list-h5' : 'dialog-item-list-web'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(actionItems), (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (item.renderCondition())
                ? (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: "list-item",
                    onClick: ($event: any) => (getFunction(index)),
                    onMousedown: ($event: any) => (beforeCopy(item.key))
                  }, [
                    _createVNode(Icon, {
                      file: item.iconUrl,
                      size: '15px'
                    }, null, 8, ["file"]),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(item.text), 1)
                  ], 40, _hoisted_1))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})